module.exports = __webpack_public_path__ + "static/media/no_data_empty.2c98ed56.png";